import { PersonDetailsContext } from "pages/PersonDetails";
import { useContext } from "react";

type Props = {
  inRoom?: boolean;
};

export default function NoMagazine({ inRoom = false }: Props) {
  const { user } = useContext(PersonDetailsContext);
  return (
    <div className="w-full text-center space-y-5 py-16">
      <p className="text-lg text-[#5E6278] font-semibold">
        {inRoom
          ? "No public magazine content in this room."
          : `${user.nickName} has no public magazine content yet.`}
      </p>
      <p className="text-sm text-[#9A9EB1] font-medium">
        No public magazine content to show.
      </p>
    </div>
  );
}
